import { Context } from "urql";
import { publicConfig } from "@lululemon/ecom-core";
import { log } from "@lululemon/mwa-utils";
import { productDetailsQuery } from "./quick-view-modal.queries";

/**
 * This function is a copy and past from packages/ecom-common/src/components/quick-view-modal-old/fetchProduct.js
 * The reason to copy this is to prepare this component to be migrated to v3
 * @param {*} params
 * @param {*} graphqlClient
 * @returns
 */
const fetchProductDetails = async (params = {}, graphqlClient) => {
  try {
    const apiHost = `${publicConfig?.apiHost}`;
    const KIWI_PATH = "/cne/graphql";
    Context.url = `${apiHost}${KIWI_PATH}`;

    const { data, error } = await graphqlClient
      .query(productDetailsQuery, { ...params }, Context)
      .toPromise();

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    log.error(
      `Error fetching product details response: ${error?.message || error}`,
      {
        isRedirect: false,
        error,
      },
      { tags: { isMainPurchaseFlow: true } }
    );

    throw error;
  }
};

export default fetchProductDetails;
